import { getCurrentUserName } from './auth';
import { resolveBranchForPrint } from './branchPrint';

const fmt = (v) => parseFloat(v || 0).toFixed(2);

const money = (v) =>
  parseFloat(v || 0).toLocaleString('en-LK', { style: 'currency', currency: 'LKR' });

export const printRentalInvoice = (invoice = {}) => {
  const preparedBy = getCurrentUserName();
  const win = window.open('', '_blank', 'width=800,height=700,scrollbars=yes,resizable=yes');
  if (!win) {
    alert('Please allow pop-ups to view or print the invoice');
    return;
  }

  const baseUrl = window.location.origin;
  const logoUrl = `${baseUrl}/LOGOFile.png`;
  const items = invoice.items || [];
  const invNum = invoice.invoice_number || 'INVOICE';
  const cycleMap = { daily: 'Daily', weekly: 'Weekly', monthly: 'Monthly' };
  const cycle = cycleMap[String(invoice.billing_cycle || 'monthly').toLowerCase()] || 'Monthly';
  const branch = resolveBranchForPrint({
    branchName: invoice.branch_name || invoice.branch?.name,
    branchCode: invoice.branch_code || invoice.branch?.branch_code,
    branch: invoice.branch
  });

  const itemsHtml = items.map((item) => `
    <tr>
      <td>
        <div class="product-name">${item.product_name || '-'}</div>
        <div class="product-code">${(item.serials || []).join(', ') || item.serial_number || ''}</div>
      </td>
      <td>${item.quantity || 1}</td>
      <td class="right">${fmt(item.period_rate)}</td>
      <td class="right">${fmt((item.period_rate || 0) * (item.quantity || 1))}</td>
    </tr>
  `).join('');

  win.document.write(`
<!DOCTYPE html>
<html>
<head>
  <title>Rental Invoice ${invNum}</title>
  <base href="${baseUrl}/">
  <style>
    @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600&family=Roboto+Mono:wght@400;500&display=swap');
    * { margin: 0; padding: 0; box-sizing: border-box; }
    @media print {
      @page { size: A4; margin: 0.5cm; }
      body { margin: 0; padding: 0; }
      .no-print { display: none !important; }
    }
    body {
      font-family: 'Poppins', sans-serif;
      font-size: 11px;
      padding: 8px;
      max-width: 210mm;
      margin: 0 auto;
      background: white;
      color: #333;
    }
    .receipt-container { border: 1px solid #ddd; padding: 12px; border-radius: 8px; }
    .header {
      display: flex; align-items: center; justify-content: space-between;
      margin-bottom: 12px; padding-bottom: 8px; border-bottom: 2px solid #1976d2;
    }
    .company-logo { height: 110px; width: auto; max-width: 250px; object-fit: contain; }
    .company-info { flex: 1; text-align: right; }
    .company-name { font-size: 14px; font-weight: 700; color: #1976d2; }
    .store-info { font-size: 11px; color: #666; margin-top: 3px; line-height: 1.3; }
    .invoice-header {
      display: flex; justify-content: space-between; align-items: center;
      margin-bottom: 10px; padding: 6px 10px; background: #f5f5f5; border-radius: 4px;
    }
    .invoice-title { font-size: 16px; font-weight: 600; color: #1976d2; }
    .invoice-number { font-family: 'Roboto Mono', monospace; font-size: 14px; }
    .customer-info {
      margin-bottom: 10px; padding: 6px 10px; background: #f9f9f9; border-left: 3px solid #1976d2;
    }
    table { width: 100%; border-collapse: collapse; margin: 8px 0; }
    th { background: #1976d2; color: white; padding: 8px 6px; text-align: left; font-size: 11px; }
    td { padding: 6px; border-bottom: 1px solid #eee; vertical-align: top; }
    .product-name { font-weight: 600; font-size: 12px; }
    .product-code { color: #666; font-size: 9px; }
    .right { text-align: right; }
    .total-row { background: #e3f2fd; font-weight: 700; }
    .footer { margin-top: 16px; text-align: center; }
    .signature-section { display: flex; justify-content: space-between; margin: 16px 0; font-size: 11px; }
    .print-button {
      position: fixed; bottom: 20px; right: 20px; background: #1976d2; color: white;
      border: none; padding: 10px 20px; border-radius: 4px; font-size: 13px; cursor: pointer; font-weight: 600;
    }
  </style>
</head>
<body>
  <div class="receipt-container">
    <div class="header">
      <div><img src="${logoUrl}" alt="Logo" class="company-logo" onerror="this.style.display='none'"></div>
      <div class="company-info">
        <div class="company-name">IT Professionals Since 1997</div>
        <div class="store-info">
          1118, Pannipitiya Road, Wickramasinghepura, Thalawathugoda<br>
          Tel: 011 27 96 579 | 94 77 987 1130<br>
          Email: info@sunsystems.lk | Web: sunsystems.lk
        </div>
      </div>
    </div>

    <div class="invoice-header">
      <div>
        <span class="invoice-title">RENTAL INVOICE</span>
        <div style="margin-top:4px;font-size:10px;color:#1565c0;font-weight:600;">Branch: ${branch.label}</div>
      </div>
      <div><span class="invoice-number">#${invNum}</span></div>
    </div>

    <div class="customer-info">
      <table style="width:100%;border:none;">
        <tr>
          <td style="border:none;padding:3px;"><strong>Customer:</strong> ${invoice.customer?.name || '-'}</td>
          <td style="border:none;padding:3px;"><strong>Phone:</strong> ${invoice.customer?.phone || '-'}</td>
        </tr>
        <tr>
          <td style="border:none;padding:3px;"><strong>Rental:</strong> ${invoice.rental_number || '-'}</td>
          <td style="border:none;padding:3px;"><strong>Billing:</strong> ${cycle}</td>
        </tr>
        <tr>
          <td style="border:none;padding:3px;"><strong>Period:</strong> ${invoice.period_start || '-'} → ${invoice.period_end || '-'}</td>
          <td style="border:none;padding:3px;"><strong>Due date:</strong> ${invoice.due_date || '-'}</td>
        </tr>
        <tr>
          <td style="border:none;padding:3px;"><strong>Status:</strong> ${invoice.display_status || invoice.payment_status || '-'}</td>
          <td style="border:none;padding:3px;"><strong>Contract:</strong> ${invoice.start_date || '-'} → ${invoice.end_date || '-'}</td>
        </tr>
      </table>
    </div>

    <table>
      <thead>
        <tr>
          <th style="width:50%;">Item</th>
          <th style="width:10%;">Qty</th>
          <th style="width:20%;" class="right">${cycle} rate (LKR)</th>
          <th style="width:20%;" class="right">Amount (LKR)</th>
        </tr>
      </thead>
      <tbody>${itemsHtml || '<tr><td colspan="4" style="text-align:center;">No items</td></tr>'}</tbody>
    </table>

    <table>
      <tr class="total-row"><td class="right" style="width:80%;"><strong>TOTAL (LKR):</strong></td><td class="right"><strong>${fmt(invoice.amount)}</strong></td></tr>
      <tr><td class="right"><strong>Paid:</strong></td><td class="right">${fmt(invoice.paid_amount)}</td></tr>
      <tr><td class="right"><strong>Balance due:</strong></td><td class="right"><strong>${fmt(invoice.balance)}</strong></td></tr>
      ${parseFloat(invoice.deposit || 0) > 0 ? `<tr><td class="right"><strong>Deposit on file:</strong></td><td class="right">${fmt(invoice.deposit)}</td></tr>` : ''}
    </table>
    ${invoice.payment_notes ? `<p style="margin:8px 0;padding:6px 10px;background:#fff8e1;border-left:3px solid #f9a825;white-space:pre-wrap;"><strong>Notes:</strong> ${invoice.payment_notes}</p>` : ''}

    <div class="footer">
      <p style="margin:8px 0 12px;font-size:12px;"><strong>Prepared by:</strong> ${preparedBy}</p>
      <div class="signature-section">
        <div style="text-align:center;width:45%;">..........................................................<br><strong>Authorize signature</strong><br>${preparedBy}</div>
        <div style="text-align:center;width:45%;">..........................................................<br><strong>Customer signature</strong></div>
      </div>
      <hr style="border:none;border-top:2px solid #1976d2;margin:8px 0;">
      <p style="font-size:13px;font-weight:600;color:#1976d2;">Thank you for choosing Sun Systems International – We value your trust!</p>
      <p style="font-size:10px;font-weight:700;">Your End-to-End IT Hardware Partner</p>
      <p style="font-size:11px;">• Retail • Repair • Service • Rental • Web Development • System Development • Corporate IT Support • Distribution • Institutional Projects</p>
      <p style="font-size:10px;font-weight:600;">Affordable. Reliable. Guaranteed.</p>
      <hr style="border:none;border-top:1px dashed #ddd;margin:6px 0;">
      <p style="font-size:11px;">ERP System Developed by Sun Systems International | Contact: 94 77 987 1130</p>
    </div>
  </div>
  <button class="print-button no-print" onclick="window.print();">Print / Save as PDF</button>
</body>
</html>
  `);

  win.document.close();
  win.focus();
};

export { money };
export default printRentalInvoice;
